import {addHours, startOfDay} from 'date-fns';

export function middleOfDay(val: number | Date) {
  return addHours(startOfDay(val), 12).getTime();
}
